import { Box, Grid, useTheme, Typography } from '@mui/material';
import Image from 'mui-image';
import React from 'react';

import { useMainLayoutContext } from '../../../layouts/MainLayoutContext';
import bubbleYellowImage from '../../../assets/images/pngs/bubble_yellow.png';
import bubbleBlueImage from '../../../assets/images/pngs/bubble_blue.png';
import bubbleGreenImage from '../../../assets/images/pngs/bubble_green.png';
import bubbleRedImage from '../../../assets/images/pngs/bubble_red.png';

export const Step3OutcomeDataExamplePage = () => {
  const theme = useTheme();
  const { updateContextValue } = useMainLayoutContext();

  React.useEffect(() => {
    updateContextValue({
      title: 'Clarifying Outcome Data Collection',
      pageContainerSx: { maxWidth: theme.breakpoints.values.md },
    });

    return () => {
      updateContextValue({ title: undefined, pageContainerSx: undefined });
    };
    // eslint-disable-next-line
  }, []);
  return (
    <Grid container>
      <Grid container item xs={12} sm={6}>
        <Grid item xs={6} sx={{ position: 'relative' }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              width: 224,
            }}
          >
            <Image src={bubbleYellowImage} duration={0} />
            <Typography sx={{ fontWeight: 600, mt: 1, fontSize: 20 }}>
              QUESTION
            </Typography>
          </Box>
          <Box
            sx={{ position: 'absolute', inset: 0, px: 4, pt: 4, width: 224 }}
          >
            <Typography sx={{ fontWeight: 500, fontSize: 14 }}>
              What is the change in the rate of tobacco retail compliance checks
              in our community?
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={6} sx={{ mt: 20, position: 'relative' }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              width: 224,
            }}
          >
            <Image src={bubbleBlueImage} duration={0} />
            <Typography sx={{ fontWeight: 600, mt: 1, fontSize: 20 }}>
              INDICATOR
            </Typography>
          </Box>
          <Box
            sx={{ position: 'absolute', inset: 0, px: 3, pt: 5, width: 224 }}
          >
            <Typography sx={{ fontWeight: 500, fontSize: 16 }}>
              Change in the number of compliance checks conducted by the
              department.
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <Grid item container xs={12} sm={6}>
        <Grid item xs={6} sx={{ position: 'relative' }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              width: 224,
            }}
          >
            <Image src={bubbleGreenImage} duration={0} />
            <Typography sx={{ fontWeight: 600, mt: 1, fontSize: 20 }}>
              DATA
            </Typography>
          </Box>
          <Box
            sx={{ position: 'absolute', inset: 0, pl: 2, pt: 8, width: 224 }}
          >
            <Typography sx={{ fontWeight: 500, fontSize: 15 }}>
              ● Interview key participants
            </Typography>
            <Typography sx={{ fontWeight: 500, fontSize: 14 }}>
              ● Staff record/log
            </Typography>
            <Typography sx={{ fontWeight: 500, fontSize: 14 }}>
              ● Tobacco Retailer Access CO (TRAC)
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={6} sx={{ mt: 20, position: 'relative' }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              width: 275,
            }}
          >
            <Image src={bubbleRedImage} duration={0} />
            <Typography sx={{ fontWeight: 600, mt: 1, fontSize: 20 }}>
              TIMING
            </Typography>
          </Box>
          <Box
            sx={{ position: 'absolute', inset: 0, px: 5, pt: 7, width: 275 }}
          >
            <Typography sx={{ fontWeight: 500, fontSize: 14 }}>
              ● Baseline: interview before implementation.
            </Typography>
            <Typography sx={{ fontWeight: 500, fontSize: 14 }}>
              ● Post: Six months after the project is finished.
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};
